// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2965":"efb9c432","5670":"2c811773","6104":"efb9c432","7636":"19d9012e","8696":"92601c81","9707":"efb9c432"}[chunkId] + ".chunk.css";
};